// Historical rail events — M2 (design §12 tier 1). Every card fires on its real
// date, every playthrough (design decision #2: true timeline, always). Cards are
// NEWS — the mechanical macro lives in the content curves (sentiment, IPO window,
// TAM, capital scale, public-company costs), so the engine stays history-free.
// The edutainment pillar rides in `body`: the "what really happened" footnote.

import type { TickContext } from "../ctx.js";
import { emit } from "../ctx.js";

export function processHistory(ctx: TickContext): void {
  const m = ctx.s.monthIndex;
  for (const ev of ctx.content.events) {
    if (ev.month === m) {
      emit(ctx, "history", ev.headline, { id: ev.id, body: ev.body });
    }
  }
}
